/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal[_ngcontent-%COMP%]{display:flex;flex-direction:column}.modal__close[_ngcontent-%COMP%]{margin-bottom:4px;align-self:flex-end;cursor:pointer}.modal__contents[_ngcontent-%COMP%]{display:flex;flex-flow:column;height:100vh}.modal__frame[_ngcontent-%COMP%]{flex:1 1 auto;display:flex}"];
export { styles as styles };
